import { MutationTree } from 'vuex'

import { Mutations, RootState, SupportedLanguages, Translations } from './types'

const mutations: MutationTree<RootState> = {
  [Mutations.SWITCH_LANGUAGE](state, value: SupportedLanguages) {
    state.chosenLanguage = value
    localStorage.setItem('language_code', value)
  },

  [Mutations.SET_TRANSLATIONS](state, value: Translations) {
    state.translations = value
  },
}

export default mutations
